import { Cards, CardsProps } from "./components/cards.tsx";
import { ColumnHeaders } from "./components/column-headers.tsx";
import { Layout } from "./components/layout.tsx";

const UniformRoadmapFeatures = () => {
    return (
        <Layout
            columnHeaders={<ColumnHeaders />}
            cards={<Cards onClick={noop} features={mockFeatures} />}
        />
    );
};

export default UniformRoadmapFeatures;

// todo: @bsparks remove this upon API integration
const noop = () => void 0;

// todo: @bsparks remove this upon API integration
const mockFeatures: CardsProps["features"] = [
    {
        featureName: "AI-assisted backlog grooming",
        category: "Automation",
        status: "future",
        timeFrame: "Q3 2025",
        apps: ["Jira", "Confluence"],
        slug: "ai-assisted-backlog-grooming",
        description:
            "Use AI to automatically prioritize and organize your backlog items based on team velocity and project goals."
    },
    {
        featureName: "Team health dashboard",
        category: "Reporting",
        status: "released",
        timeFrame: "Q4 2025",
        apps: ["Jira", "JSM"],
        slug: "team-health-dashboard",
        description:
            "Get real-time insights into your team's performance, workload distribution, and sprint health metrics."
    },
    {
        featureName: "Cross-project goals",
        category: "Planning",
        status: "coming soon",
        timeFrame: "Available now",
        apps: ["Jira Software", "Jira Work Management"],
        slug: "cross-project-goals",
        description:
            "Align objectives across multiple projects and track progress toward shared organizational goals."
    },
    {
        featureName: "Cross-project goals",
        category: "Planning",
        status: "completed",
        timeFrame: "Available now",
        apps: ["Jira Software", "Jira Work Management"],
        slug: "cross-project-goals",
        description:
            "Align objectives across multiple projects and track progress toward shared organizational goals."
    }
];
